import { motion } from "framer-motion";
import { Box, Repeat, Wrench, PenTool, Layers3, Settings2 } from "lucide-react";
import SectionHead from "../SectionHead";

const ITEMS = [
    { icon: PenTool, label: "Drawing-based mould development" },
    { icon: Box, label: "Prototype tooling" },
    { icon: Layers3, label: "Production moulds" },
    { icon: Wrench, label: "Mould modification" },
    { icon: Settings2, label: "Component-specific fixtures" },
    { icon: Repeat, label: "Repeat production tooling" },
];

export const Tooling = () => (
    <section id="tooling" className="py-24 md:py-32 scroll-mt-20">
        <div className="shell">
            <SectionHead
                num="05"
                overline="Tooling & Mould Development"
                title="Tooling that repeats, batch after batch"
            />

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-800 border border-zinc-800">
                {ITEMS.map((item, i) => (
                    <motion.div
                        key={item.label}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                        data-testid={`tooling-item-${i + 1}`}
                        className="group bg-[#0e0e11] hover:bg-panel transition-colors duration-300 p-6 md:p-8"
                    >
                        <item.icon
                            size={24}
                            strokeWidth={1.5}
                            className="text-safety mb-6"
                        />
                        <div className="font-display uppercase font-medium tracking-wide text-lg text-zinc-200 group-hover:text-safety transition-colors">
                            {item.label}
                        </div>
                    </motion.div>
                ))}
            </div>

            <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="mt-10 max-w-3xl text-zinc-400 text-sm md:text-base leading-relaxed border-l-2 border-safety pl-6"
            >
                Our tooling approach is focused on maintaining{" "}
                <span className="text-zinc-100">repeatability</span> and{" "}
                <span className="text-zinc-100">dimensional consistency</span>{" "}
                during production.
            </motion.p>
        </div>
    </section>
);

export default Tooling;